<template>
  <div class="empty:hidden bg-white relative z-40">
    <!-- Global banners -->
    <LazyAppMasquerade v-if="isMasquerading" />

    <LazyAppUpgradeBrowser v-if="shouldShowUpgradeBrowser" />

    <!-- Default layout banners -->
    <template v-if="!isWebView">
      <LazyAppMobileAppDownloadBanner v-if="!route.meta?.hideDownloadAppBanner && shouldShowDownloadAppBanner" />

      <LazyBannersCanada v-if="shouldShowCanadaBanner" />

      <LazyBannersPromotional v-if="shouldShowPromotionalBanner" />

      <LazyBannersSuspended v-if="showSuspendedBanner" />
    </template>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const {
  isRenderedHomePage,
  isRenderedRvSearchPage,
  isRenderedRvRentalsOrChildPage,
} = useBaseName()

/**
 * Masquerade banner
 */
const { isMasquerading } = useMasquerade()

/**
 * Upgrade browser banner
 */
const { isRecognizedBrowser, isFullySupported } = useBrowserSupport()
const shouldShowUpgradeBrowser = computed(() => {
  return isRecognizedBrowser && !isFullySupported
})

/**
 * Download App banner.
 *
 * The download app banner should show when the user is not in a webview, and
 * hasn't dismissed the banner yet.
 */
const { isMobileOrTablet } = useDevice()
const shouldShowDownloadAppBanner = computed(() => {
  return !isWebView.value && isMobileOrTablet
})

/**
 * Suspended banner
 */
const { isFeatureEnabled, showCanadianOwnerBanner, showTravelTrailerDiscountBanner } = useExperiment()
const { isSuspended } = useNotificationsData()
const showSuspendedBanner = computed(() => {
  return Boolean(route.meta?.showSuspendedBanner) && isSuspended.value && isFeatureEnabled('rvz23061SuspendedHostBanner')
})

/**
 * Canada banner.
 *
 * The canadian banner should show when the user is not using a webview, and
 * hasn't dismissed the banner yet.
 */
const { isWebView } = usePlatform()

const shouldShowCanadaBanner = computed(() => {
  return !isWebView.value
    && (isRenderedHomePage.value || isRenderedRvSearchPage.value)
    && showCanadianOwnerBanner.value
})

const shouldShowPromotionalBanner = computed(() => {
  return (isRenderedHomePage.value || isRenderedRvSearchPage.value || isRenderedRvRentalsOrChildPage.value)
    && showTravelTrailerDiscountBanner.value
})
</script>
